module.exports = __webpack_public_path__ + "649aeab666e02068fb04275c509e842f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/credit-header-bg.jpg
// module id = 127
// module chunks = 0